import { CloseCircleOutlined } from "@ant-design/icons";
import { Button, Col, Modal, Row } from "antd";
import dayjs from "dayjs";
import { IStaffDetails } from "features/storeManagement/interface/IStoreManagement";
import { UserManagementConstants } from "features/userManagement/constants/UserManagementConstants";
import { isNull, isObject, isUndefined } from "lodash";
import { DataFormat } from "utils/format/DataFormat";
import { NumberFormat } from "utils/format/NumberFormat";
import { renderStatus } from "utils/helpersInTs/helpersInTs";
import { strings } from "utils/localizedStrings";

const UserDetailsFeature = (props: IStaffDetails) => {
  const { user, visible, onClose } = props?.data;

  const detailSection = (localStrings: typeof strings) => {
    return Object?.entries(localStrings.UserManagement.StaffColumns)?.map(
      ([key, val]) =>
        !isUndefined(user[key]) && !isNull(user[key]) ? (
          <Col span={24}>
            {DataFormat.renderItem(
              isObject(val) ? "" : val,
              key === "createdAt"
                ? dayjs(user[key]).format("DD/MM/YYYY HH:mm:ss")
                : key === "type"
                ? UserManagementConstants.userTypeMapping(user[key], strings)
                : key === "status"
                ? renderStatus(user[key])
                : key === "wallet"
                ? NumberFormat.currencyFormat(
                    user[key]?.balance,
                    user[key]?.currency
                  )
                : key === "role"
                ? user[key]?.name
                : user[key]
            )}
          </Col>
        ) : (
          <></>
        )
    );
  };

  if (!user) return <></>;

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      closeIcon={null}
      width={600}
      centered
      styles={{
        body: {
          overflowY: "auto",
          maxHeight: "calc(100vh - 120px)",
          scrollbarWidth: "none",
          overflowX: "hidden",
        },
        content: {
          padding: 0,
        },
        header: {
          padding: 5,
          width: "100%",
        },
      }}
      title={
        <div className="flex py-3 px-2 justify-between w-full border-b-[1px] border-b-[#E5E5E5]">
          <div className="w-1 h-1"></div>
          <span className="font-bold">{strings.GlobalLabels.Detail}</span>
          <CloseCircleOutlined
            onClick={onClose}
            style={{ color: "black", fontSize: "20px" }}
          />
        </div>
      }
    >
      <section className="flex w-full xl:px-[35px] px-3">
        <Row gutter={[8, 8]} justify={"start"} className="mt-4 mb-10">
          {detailSection(strings)}
          <Col
            span={24}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 10,
            }}
          >
            <Button
              type="primary"
              className="xl:h-[50px] xl:w-1/3 w-2/3 h-[40px] font-[600]"
              size="large"
              onClick={onClose}
            >
              {strings.GlobalLabels.Close}
            </Button>
          </Col>
        </Row>
      </section>
    </Modal>
  );
};

export default UserDetailsFeature;
